import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { UnitsServiceProxy, CreateOrEditUnitDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditUnitModal',
    templateUrl: './create-or-edit-unit-modal.component.html',
    standalone: false,
})
export class CreateOrEditUnitModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    unit: CreateOrEditUnitDto = new CreateOrEditUnitDto();

    constructor(
        injector: Injector,
        private _unitsServiceProxy: UnitsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(unitId?: number): void {
        if (!unitId) {
            this.unit = new CreateOrEditUnitDto();
            this.unit.id = unitId;

            this.active = true;
            this.modal.show();
        } else {
            this._unitsServiceProxy.getUnitForEdit(unitId).subscribe((result) => {
                this.unit = result.unit;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._unitsServiceProxy
            .createOrEdit(this.unit)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
